import { Component, OnInit, Input } from '@angular/core';
import { HomeDriverCentersComponent } from 'app/home';

@Component({
    selector: 'driver-centers-filter',
    templateUrl: './driver-centers-filter.component.html',
    styleUrls: ['./driver-centers-filter.component.scss']
})
export class DriverCentersFilterComponent implements OnInit {
    @Input()
    public homeDriverCentersComponent!: HomeDriverCentersComponent;

    public city: string = '';

    constructor() { }

    ngOnInit(): void {
    }

    public clickFilter() {
        this.homeDriverCentersComponent.filter.city = this.city;
        this.homeDriverCentersComponent.visibleUserFilter = false;
        this.homeDriverCentersComponent.getXpressCenters(0);
    }
}
